import { generatePath } from "react-router";

import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { StartGuideChecklist } from "@/components/features-new/start-guide-checklist";

import { useConfirmParams } from "./hooks";

export const StartGuideChecklistPage = () => {
	const result = useConfirmParams();

	const { canRender } = result;
	if (!canRender) return <></>;

	const { hotelID } = result;

	return (
		<PageMeta title="販売前最終チェック表" url={generatePath(PATHS.HOTEL.START_GUIDE_CHECKLIST, { hotelID })}>
			<StartGuideChecklist hotelID={hotelID} />
		</PageMeta>
	);
};
